// extracted by mini-css-extract-plugin
module.exports = {"daily-count":"DailyCount_daily-count__NRxgz","icons-container":"DailyCount_icons-container__41zv2"};